export default "__VITE_ASSET__8322cb3f__"